/**
 * Concept Archetype
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */
 
import _ from 'lodash'


const   baseController = 'monedero',
        baseIndex = baseController + '/index',
        userIndex = baseController + '/byuser/',
        summaryIndex = baseController + '/summarybyuser/';

const   revisorLabel = 'Revisor',
        transferenciaLabel = 'Transferencia'

let getSummaryAPI = (userId) => {
    return (summaryIndex + userId)
}

let getCorrectAPI = (userId) => {
    return (parseInt(userId)) ? (userIndex + userId) : baseIndex
}

const archetype = [
     // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id',
        type: 'hidden'
    },
    [{key: 'imagen_transferencia', label: transferenciaLabel, type: 'imageurl'}],
    [{key: 'cantidad', type: 'price', readonly: true}],
    null,
    [{key: 'usuario_id_pk', type: 'select', options: [],  label: 'Usuario'}],
    [{key: 'estatus', type: 'select', options: ['Sin revisión','Revisado','Rechazado'], default: 'Revisado', readonly: false}],
    null,
    [{key: 'usuario_id_pk_auditor', type: 'select', options: [], readonly: true, label: revisorLabel}],
    [
        {key: 'created', type: 'text', readonly: true},
        {key: 'modified', type: 'text', readonly: true}
    ],
    null,
    [
        {key: 'concepto'}
    ],
    [
        {key: 'comentarios', type: 'textarea'}
    ]
];

const captions = [
    {key: 'imagen'},
    {key: 'nombreCompleto'},
    {key: 'membresia'},
    {key: 'imagen_transferencia', label: transferenciaLabel},
    {key: 'cantidad'},
    {key: 'estatus'},
    {key: 'usuario_id_pk_auditor', label: revisorLabel},
    {key: '_'},
]

let captionsForUser = _.filter(captions, cap => {   
    return (['nombreCompleto', 'imagen', 'membresia'].indexOf(cap.key) === -1)
})

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}
let getArchetype = () => {
    return _.cloneDeep(archetype);
}

export {

    captionsForUser,

    archetype,
    captions,
    baseIndex,

    getArchetype,
    automodalHandler,
    getCorrectAPI,
    getSummaryAPI
}